import { Collapse } from "antd";
import React from "react";
import Label from "./Label";
import Children from "./Children";
function Notes({notes,farmerId}) {
  const items = [
    {
      key: "2",
      label: <Label />,
      children: <Children childrenNote={notes} farmerId={farmerId} />,
    },
  ];
  return (
    <Collapse size="small" className="bg-white whitespace-nowrap" expandIconPosition={"end"} items={items} />
  );
}

export default Notes;
